import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M8 1.26A6.75 6.75 0 1 0 14.75 8 6.76 6.76 0 0 0 8 1.26Zm0 11.45a.89.89 0 1 1 .89-.89.89.89 0 0 1-.89.89ZM9.3 8.2v.05c-.17.19-.47.5-.47.65a.75.75 0 0 1-1.5 0 2.53 2.53 0 0 1 .88-1.68l.08-.08c.53-.56.58-.61.58-1.22A.72.72 0 0 0 8 5.27a.72.72 0 0 0-.76.73.75.75 0 0 1-1.5 0A2.2 2.2 0 0 1 8 3.77 2.2 2.2 0 0 1 10.29 6a2.67 2.67 0 0 1-.99 2.2Z';
const draw24px = 'M12,2.25A9.75,9.75,0,1,0,21.76,12,9.76,9.76,0,0,0,12,2.25Zm0,16.82a1.34,1.34,0,1,1,1.34-1.34A1.34,1.34,0,0,1,12,19.07Zm2.17-7c-.19.16-.4.34-.62.55a1.8,1.8,0,0,0-.56,1,1,1,0,0,1-1,1h0a1,1,0,0,1-1-1,3.73,3.73,0,0,1,1.17-2.48l.71-.63c.7-.6.89-.76.89-1.63A1.64,1.64,0,0,0,12,7.35,1.64,1.64,0,0,0,10.26,9a1,1,0,0,1-2,0A3.63,3.63,0,0,1,12,5.35a3.6,3.6,0,0,1,3.77,3.57A3.56,3.56,0,0,1,14.19,12.07Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const QuestionCircleFilledIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'questionCircleFilled'));
QuestionCircleFilledIcon.displayName = 'QuestionCircleFilledIcon';
QuestionCircleFilledIcon.propTypes = Icon.propTypes;
QuestionCircleFilledIcon.renderIcon = props => /*#__PURE__*/React.createElement(QuestionCircleFilledIcon, props);
export default QuestionCircleFilledIcon;
//# sourceMappingURL=QuestionCircleFilledIcon.js.map